const Button = ({onClick, text, disabled}) => (
    <>  
    <button className="bg-sky-500 hover:bg-sky-400 text-grey-darkest font-bold py-1 px-2  inline-flex items-center text-white" onClick={onClick} disabled={disabled}>{text}</button>
    </>
) 

export default Button;